<template>
  <div
    ref="cont"
    class="ra_table ra_table-container text-noselect"
    @mouseleave="handleTableMouseleave"
  >
    <RangeTableCell
      v-for="combos in tableGroups"
      :id="`${idPrefix || playerKey}_${combos.id}`"
      :key="combos.id"
      :data-tst="`range_table_cell_${playerKey}_${combos.id}`"
      class="ra_table_cell"
      :combos="combos"
      :combosPlayer="combos.players[playerKey]"
      :range="combos.players[playerKey]?.[rangeKey]"
      :asEmpty="asEmpty"
      :noValue="noValue"
      :showProp="showProp"
      :valueProp="valueProp"
      :noTitle="noTitle"
      :player="playerKey"
      :grouping="grouping"
      :isCentered="isCentered"
      :useHex="useHex"
      :active="combos.id === playerDetail.group_id"
      :showBetsIn="showBetsIn"
      :bettingInfo
      :filterEvCompare="filterEvCompare"
      :viewProps="viewProps"
      :filterCombos="filterCombos"
      :evProps="evProps"
      :rangeKey="rangeKey"
      :isDimmed="playerDetail.groups_ids ? !playerDetail.groups_ids.includes(combos.id) : false"
      :isLocked="canBeLocked && combos.is_locked"
      @mouseenter="setHoveredCombos"
      @mousedown="handleMouseDown"
      @click="toggleClickCombos"
    >
    </RangeTableCell>
  </div>
</template>

<script>
import { SNK } from '@/helpers/helpers'
import RangeTableCell from '@/components/Study/RangeTableCell'
import tier_mix from '@/mixins/tier_mix'

export default {
  name: 'StudyRangeTable2',
  components: {
    RangeTableCell,
  },
  mixins: [tier_mix],
  props: {
    namespace: String,
    playerKey: { default: () => '0' },
    tableGroups: { default: () => [] },
    noTitle: { default: () => false },
    setHoveredComboForLeftPlayerOnly: Boolean,
    canBeLocked: { type: Boolean, default: true },

    idPrefix: String,
    playersDetail: { default: () => [] },
    viewProps: Object,
    filterCombos: Object,
    evProps: Object,
    useHex: Boolean,
    showBetsIn: String,
    bettingInfo: Object,
    grouping: String,
    filterEvCompare: Object,

    showProp: String,
    asEmpty: Boolean,
    noValue: Boolean,
    valueProp: String,
    isCentered: Boolean,
    tableMouseover: Boolean,
    rangeKey: String,

    asideTabKey: { default: () => 'sw_tabs_handmatrix' },
  },
  emits: ['combo:mousedown', 'combo:click', 'combo:mouseenter', 'table:mouseleave'],
  data() {
    return {
      clrs: [],
      lastTab: '',
    }
  },
  methods: {
    handleMouseDown({ e, combos, disabled, trigger }) {
      this.$emit('combo:mousedown', { e, combos, disabled, trigger })
    },
    toggleClickCombos({ e, combos, disabled, trigger }) {
      if (disabled) return
      const group = this.playerDetail.group_id === combos.id ? null : combos

      const mm = [
        {
          key: 'study_player',
          value: this.playerKey,
        },
        {
          key: 'players_detail',
          playerProperty: 'group_id',
          value: '',
        },
        {
          key: 'players_detail',
          playerProperty: 'group_id',
          player: this.playerKey,
          value: group?.id || '',
        },
        { key: 'players_detail', playerProperty: 'group', player: this.playerKey, value: combos },
        {
          key: 'players_detail',
          playerProperty: 'hands_ids',
          player: this.playerKey,
          value: combos.combos.map(c => c.id),
        },
      ]

      mm.forEach(m => {
        this.$store.commit(SNK('sol_detail_set', this.namespace), m)
      })

      this.$emit('combo:click', {
        event: e,
        combos,
        showProp: this.showProp,
        player: this.playerKey,
        disabled,
        trigger,
      })
    },
    setHoveredCombos({ e, combos, disabled, trigger }) {
      this.$emit('combo:mouseenter', { e, combos, disabled, trigger })
      if (this.mobile) return

      const playerHasGroupId = this.playersDetail.find(i => i.group_id)
      const heroGroupId = this.playersDetail[0]?.group_id

      if (this.setHoveredComboForLeftPlayerOnly ? heroGroupId : playerHasGroupId?.group_id) {
        return
      }

      if (disabled) {
        if (this.tableMouseover) {
          this.handleTableMouseleave()
        }
        return
      }
      if (!this.tableMouseover) {
        this.handleTableMouseenter()
      }

      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'study_player',
        value: this.playerKey,
      })

      // Reset all players hands_ids
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'hands_ids',
        value: null,
      })
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'group',
        value: combos,
        player: this.playerKey,
      })
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'hands_ids',
        player: this.playerKey,
        value: combos.combos.map(c => c.id),
      })
    },
    handleTableMouseenter() {
      const hasGroupId = this.playersDetail.some(i => i.group_id)
      if (this.mobile || hasGroupId) return

      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'study_table_mouseover',
        value: true,
      })
      this.lastTab = this.$store.getters[this.asideTabKey]
      if (this.lastTab === 'filters') {
        this.$store.dispatch('switchers_set_item_by_value', {
          key: this.asideTabKey,
          value: 'hands',
        })
      }
    },
    handleTableMouseleave() {
      this.$emit('table:mouseleave')
      const hasGroupId = this.playersDetail.some(i => i.group_id)
      if (this.mobile || hasGroupId) return

      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'study_table_mouseover',
        value: false,
      })
      if (this.lastTab === 'filters') {
        this.$store.dispatch('switchers_set_item_by_value', {
          key: this.asideTabKey,
          value: 'filters',
        })
      }
    },
  },
  computed: {
    playerDetail() {
      return this.playersDetail[this.playerKey]
    },
  },
}
</script>

<style lang="scss" scoped>
.ra_table {
  position: relative;
  flex: 1;
  display: grid;
  &_cell {
    outline: 1px solid var(--clr-black-0);
  }
  grid-template-columns: repeat(13, 1fr);
  grid-template-rows: repeat(13, 1fr);

  background: var(--clr-black-0);
  border-radius: 6px;
  border: solid var(--clr-black-0) 1px;
}
</style>

<style lang="scss" scoped>
// .ra_table-container {
//   container-name: rtc;
//   container-type: size;
// }
// @container rtc (max-width: 546px) {
//   .rtc_value,
//   .rtc_title {
//     font-size: clamp(4px, 3cqw, 1rem) !important;
//     // display: none !important;
//   }
// }
// @container rtc (max-height: 546px) {
//   .rtc_value,
//   .rtc_title {
//     font-size: clamp(4px, 5cqw, 1em) !important;
//     // display: none !important;
//   }
// }
</style>
